import ArrowWithTail from "@/assets/icons/ArrowWithTail";
import classes from "./ImageContainerCardMobile.module.scss";
import { useRouter } from "next/navigation";
import Image from "next/image";

type Props = {
  news?: any;
};
const ImageContainerCardMobile = ({ news }: Props) => {
  const router = useRouter();
  const readMoreClick = (slug: any) => {
    router.push(`/article/${slug}`);
  };
  return (
    <div className={classes["img-container-card"]}>
      <div className={classes["image-wrapper"]}>
        <div className={classes["image"]}>
          <Image
            src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/${news.imageUrl}`}
            alt="Trending News Image"
            width={1200}
            height={800}
          />
        </div>
        <div className={classes["overlay"]}>
          <div className={classes["header"]}>
            <div className={classes["titles-container"]}>
              <span className={classes.title1}> {news.categoryName}</span>
            </div>
            <p className={classes.description}>{news.title}</p>
          </div>
          <div
            className={classes["read-more"]}
            onClick={() => readMoreClick(news.slug)}
          >
            Read More
            <span>
              <ArrowWithTail rotation={360} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageContainerCardMobile;
